export default class FilterSet {
  constructor(oldSet = []) {
    this.set = oldSet;
    this.index = 0;
  }

  [Symbol.iterator]() {
    return {
      next: () => {
        if (this.index < this.set.length) {
          return {value: this.set[this.index++], done: false};
        } else {
          this.index = 0;
          return {done: true};
        }
      }
    };
  }

  add(value) {
    if (this.set.length === 0) {
      this.set.push(value);
      return this;
    }
    for (let i = 0; i < this.set.length; i++) {
      if (this.set[i].prop === value.prop) {
        this.set[i] = value;
        return this;
      }
    }
    this.set.push(value);
    return this;
  }

  getSet() {
    return this.set;
  }

  clear() {
    this.set = [];
    this.index = 0;
    return this;
  }

  contains(value) {
    for (let i = 0; i < this.set.length; i++) {
      if (this.set[i].hasOwnProperty(value)) {
        return true;
      }
    }
    return false;
  }

  getByProp(prop) {
    for (let i = 0; i < this.set.length; i++) {
      if (this.set[i].prop === prop) {
        return this.set[i].value;
      }
    }
    return null;
  }

  get length() {
    return this.set.length;
  }
}